<template>
    <img :src="img || '/assets/images/logo.png'" alt="" class="rounded border">
</template>


<script>
import { ref, watchEffect } from "vue";

import {G} from "@/_common";

export default {
   name: 'SVGLogo',
   props:{
      width: {
         type: Number,
         default: 200
      },
      height: {
         type: Number,
         default: 200
      },
      fill: {
         type: String,
         default: '#146898'
      },
      textFill: {
         type: String,
         default: 'white'
      },
   },
   setup(){
      const img = ref();

      watchEffect(() => {
         img.value = G.systemData?.logo?.value;
      });

      return {
         img
      };
   }
}
</script>


<style lang="scss" scoped>
</style>
